import {css} from '@emotion/css';
import { ThemeProvider } from 'Shared/ThemeProvider';
import { artistTheme } from 'Shared/artists/Theme';
import { Page } from 'Shared/Page';
import { createStore } from 'solid-js/store';

export const pageName = 'artist/Manager';


export default function ArtistWrap(P)
{
	const [themeStore,setTheme] = createStore(artistTheme());

	return (
		<ThemeProvider theme={themeStore} setTheme={setTheme}>
			<Page requiresLogin={true}>
				<div class={css(artistTheme().root,artistTheme().content)}>
					{P.children}
				</div>
			</Page>
		</ThemeProvider>
	);
}

